import loadable from '@loadable/component';

export const ViewUnpublishedInternshipPageLoadable = loadable(
  () => import('./ViewUnpublishedInternshipPage'),
  { resolveComponent: (module) => module.ViewUnpublishedInternshipPage },
);
